// extracted by mini-css-extract-plugin
export var textInput = "_du-0";